import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-arts-entertain-design',
  imports: [PillarPagesTemp],
  templateUrl: './arts-entertain-design.html',
  styleUrl: './arts-entertain-design.scss',
})
export class ArtsEntertainDesign {

}
